import inputData from "@/data/input";

const { text: textInputType } = inputData.types;

const { appleId: appleIdInputName, name: nameEnInputName, nameAr: nameArInputName } = inputData.names;

const { appleId: appleIdInputLabel, name: nameEnInputLabel, nameAr: nameArInputLabel } = inputData.labels;

const contributorFormData = [
    {
        col: {
            md: 4,
            xs: 12,
        },
        label: nameEnInputLabel,
        name: nameEnInputName,
        type: textInputType,
    },
    {
        col: {
            md: 4,
            xs: 12,
        },
        hasOffset: true,
        label: nameArInputLabel,
        name: nameArInputName,
        type: textInputType,
    },
    {
        col: {
            md: 4,
            xs: 12,
        },
        isOptional: true,
        label: appleIdInputLabel,
        name: appleIdInputName,
        type: textInputType,
    },
];

export default contributorFormData;
